import _startCase from "lodash/startCase";
import _toLower from "lodash/toLower";
import moment from "moment";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import PizZipUtils from "pizzip/utils/index.js";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { DATE_FORMAT, IMAGE_EXTENTIONS, USER_TOKEN_KEY } from "./constants";




// Register the fonts with pdfMake



// import xlsx from "xlsx";
import Axios from "axios";
import JSZip from "jszip";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// import { Buffer } from "buffer";
window.moment = moment; //@remind pantek moment
let a = 100;
export const generateUniqKey = () => a++;

export const capitalizeEachWord = (string) => {
  const arr = string.split(" ");

  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }

  const str2 = arr.join(" ");
  return str2;
};

export const toFormatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = "" + d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (year.length < 4) return;

  return [year, month, day].join("-");
};

export const toLongDate = (date) => {
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const toastError = (title = "Error, try again later") => {
  toast.error(title, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const toastWarning = (title = "Error, try again later") => {
  toast.warning(title, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const toastSuccess = (title) => {
  toast.success(title, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const swalRemoveChild = () => {
  var element = document.getElementsByClassName("swal2-container swal2-center swal2-backdrop-show");
  element[0]?.classList.remove("swal2-container");
};

export const ValidateEmail = (email) => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
};

export const isImageFile = (file) => {
  return /^image\//.test(file?.type + "");
};

export const fileValidation = (file) => {
  let allowExtension = /(\.jpg|\.jpeg|\.png|\.doc|\.docx|\.xls|\.XLSX|\.pdf)$/i;
  return allowExtension.exec(file)
}

export const fileImageValidation = (file) => {
  let allowExtension = /(\.jpg|\.jpeg|\.png)$/i;
  return allowExtension.exec(file)
}

export const getFirstWord = (str) => {
  return String(str).replace(/\b\s.*/, "");
};

export const generateFileName = (tipe, originalFileName) => {
  const currentDate = new Date();
  return (
    tipe +
    currentDate.getFullYear() +
    (currentDate.getMonth() + 1) +
    currentDate.getDate() +
    currentDate.getHours() +
    currentDate.getMinutes() +
    currentDate.getSeconds() +
    "." +
    originalFileName.replace(/^.*\./g, "")
  );
};

export const extractQueryParam = (query = "") => {
  return new URLSearchParams(query);
};
//test

// export const parseExcel = (file) => {
//   return new Promise((resolve) => {
//     try {
//       let reader = new FileReader();
//       reader.onload = () => {
//         let fileData = reader.result;
//         let wb = xlsx.read(fileData, { type: "binary" });
//         const output = {};
//         wb.SheetNames.forEach((sheetName) => {
//           let rowObj = xlsx.utils.sheet_to_row_object_array(
//             wb.Sheets[sheetName]
//           );
//           output[sheetName] = rowObj;
//         });
//         resolve(output);
//       };
//       reader.onerror = () => resolve(null);
//       reader.readAsBinaryString(file);
//     } catch (error) {
//       console.log(error);
//       resolve(null);
//     }
//   });
// };

// export const isXlsxFile = (file) => {
//   return /\.xlsx/gi.test(file.name + "");
// };

// export const htmlToImage = async (element) => {
//   const input = element;
//   const canvas = await html2canvas(input, {
//     useCORS: true,
//   });
//   return canvas.toDataURL("image/png");
// };

export const swalAlert = ({ text = "", title = "Alert" }, timer = 5_000) => {
  Swal.fire({
    text,
    title,
    timer,
    position: "center",
    customClass: { container: "sweetalert-z-index" },
  });
};

export const swalConfirm = (
  { text = "Anda Yakin?", title = "Konfirmasi" },
  successCB = () => { },
  deniedCB = () => { },
  canceledCB = () => { }
) => {
  Swal.fire({
    html: "<div>" + text + "</div>",
    title,
    showConfirmButton: true,
    showCancelButton: true,
    cancelButtonColor: "#ff5e3f",
    confirmButtonColor: "#39da8a",
    confirmButtonText: "Ya",
    cancelButtonText: "Tidak",
    customClass: { container: "sweetalert-z-index" },
  }).then((res) =>
    res.isConfirmed ? successCB?.() : res.isDismissed ? deniedCB?.() : canceledCB?.()
  );
};

// export const customAxios = Axios.create({ url: ENDPOINT });
export const strMatch = (str, targetString) => {
  if (!str) return true;
  if (!targetString) return false;
  return String(targetString).toLowerCase().includes(String(str).toLowerCase());
};

export const convertDate = (dateInMs) => {
  if (!+dateInMs) return null;
  return moment(+dateInMs).format("YYYY-MM-DD HH:mm");
};

export const getMinutes = (minute = 0) => {
  return 1000 * 60 * minute;
};

export const getDate = () => moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

export const errorHandler = (func) => {
  try {
    return func();
  } catch (error) {
    return null;
  }
};

// export const utf8ToBase64 = (str) =>
//   errorHandler(() => Buffer.from(str + "", "utf-8").toString("base64"));

// export const base64ToUtf8 = (str) =>
//   errorHandler(() => Buffer.from(str, "base64").toString("utf-8"));

// export const arrayBufferToBlob = (buffer, type = "") => {
//   let blob = new Blob([buffer], { type });
//   return blob;
// };

export const downloadBlob = (blob, fileName) => {
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};

export const getBlobFromFirebaseUrl = async (firebaseUrl) => {
  try {
    const res = await Axios.get(firebaseUrl, {
      responseType: "blob",
    });
    return res.data;
  } catch (error) {
    return null;
  }
};

export const addToken = (val, useSessionStorage) => {
  (useSessionStorage ? sessionStorage : localStorage).setItem(USER_TOKEN_KEY, val);
};

export const removeToken = () => {
  sessionStorage.removeItem(USER_TOKEN_KEY);
  localStorage.removeItem(USER_TOKEN_KEY);
};

export const getToken = () => {
  return sessionStorage.getItem(USER_TOKEN_KEY) ?? localStorage.getItem(USER_TOKEN_KEY);
};

export const singkatString = (str) => {
  const splittedStr = String(str).trim().split(/\s+/);
  const firstName = splittedStr.shift();
  if (splittedStr.length < 1) return firstName;
  const singkatan = splittedStr.map((str) => str.slice(0, 1)).join(".");
  return `${firstName}.${singkatan}`;
};

export const normalizeName = (name) => {
  return _startCase(_toLower(name));
};

export const createNamaApproval = (nama) => {
  return singkatString(normalizeName(nama));
};

export const getFirstName = (name) => {
  return String(name).trim().replace(/ .*/, " ");
};

export const getInitialRangeDate = () => {
  return {
    start: moment().subtract(1, "month").format(DATE_FORMAT.DATERANGE),
    end: moment().format(DATE_FORMAT.DATERANGE),
  };
};

export const getPreDefinedDateRange = () => {
  return {
    "Hari ini": [moment().toDate(), moment().toDate()],
    Kemarin: [moment().subtract(1, "days").toDate(), moment().subtract(1, "days").toDate()],
    "7 Hari terakhir": [moment().subtract(6, "days").toDate(), moment().toDate()],
    "30 Hari Terakhir": [moment().subtract(29, "days").toDate(), moment().toDate()],
    "Bulan Ini": [moment().startOf("month").toDate(), moment().endOf("month").toDate()],
    "Bulan Lalu": [
      moment().subtract(1, "month").startOf("month").toDate(),
      moment().subtract(1, "month").endOf("month").toDate(),
    ],
  };
};

export const swalInput = async (
  { placeHolder = "...", label = "", inputType = "textarea" },
  confirmCb,
  deniedCb
) => {
  const response = await Swal.fire({
    input: inputType,
    inputLabel: label,
    inputPlaceholder: placeHolder,
    inputAttributes: {
      "aria-label": label,
    },
    showCancelButton: true,
  });

  if (response.isConfirmed) {
    confirmCb?.(response.value);
  } else {
    deniedCb?.();
  }
};

export const formatRupiah = (angka, prefix) => {
  var number_string = angka.toString().replace(/[^,\d]/g, ""),
    split = number_string.split(","),
    sisa = split[0].length % 3,
    rupiah = split[0].substr(0, sisa),
    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
  return prefix == undefined ? rupiah : rupiah ? "Rp. " + rupiah : "";
};

export const sort = (str) => {
  return str
    .split("")
    .sort((a, b) => a.localeCompare(b))
    .join("");
};

export const errMssgHelper = (str) => {
  return <p style={{ fontSize: 13 }}>{str}</p>
}

export const readFileFromInput = (e, cb) => {
  const reader = new FileReader();

  if (e.size === 0) {
    console.log("No files selected");
  }
  reader.readAsBinaryString(e);

  reader.onerror = (event) => {
    console.log("error reading file", event);
  };

  reader.onload = (event) => {
    const content = event.target.result;
    cb(null, content);
  };
};

export const loadFile = (fromInput, url, callback) => {
  fromInput ? readFileFromInput(url, callback) : PizZipUtils.getBinaryContent(url, callback);
};

export const getDataForPengantarMCU = (dataDoc) => {
  let placeholder = {
    namacandidate: dataDoc[0].datacandidatename,
    usiacandidate: dataDoc[0].datausiacandidate,
    jkcandidate: dataDoc[0].datajkcandidate,
    jabatancandidate: dataDoc[0].datajabatan,
    tglperiksa: dataDoc[0].tglperiksa
  }
  return placeholder
}

export const getDataForHasilMCU = (dataDoc) => {
  let placeholder = {
    candidatename: dataDoc[0].datacandidatename,
    tempatlahir: dataDoc[0].datatempatlahir,
    tanggallahir: dataDoc[0].datatanggallahir,
    jabatancandidate: dataDoc[0].datajabatan
  }
  return placeholder
}



export async function convertWordToPDF(wordBlob) {
  const wordArrayBuffer = await wordBlob.arrayBuffer();
  const zip = new JSZip();
  const doc = await zip.loadAsync(wordArrayBuffer);
  const content = await doc.files['word/document.xml'].async('string');
  console.log("content", await doc.files)
  const pdfDoc = await pdfMake.createPdf({
    content: content,
  });
  return pdfDoc.getBlob((blob) => {
    // const pdfArrayBuffer = new Uint8Array(blob).buffer;
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
  });
}

export const validateFileExtension = (extensions, file) =>
  extensions.some((ext) => file?.name?.toLowerCase().endsWith(ext));


export const isImageFiles = (file) => {
  console.log(file)
  return validateFileExtension(IMAGE_EXTENTIONS, file);
};

export const concateText = (str) => {
  return str?.toLowerCase().replace(/\s+/g, '-');
};









